/**
 * How long the transient snack bar notices raised from the HICAPS Connect V2
 * practice settings stay on screen. Shared by the settings page and its edit
 * dialogs so a user moving between them sees notices dismiss at one pace.
 */
export const HICAPS_SETTINGS_NOTICE_MS = 3000;
